{
    "Profile_Logs.apiLogs": "FR: API Logs",
    "Profile_Logs.event": "FR: Event",
    "Profile_Logs.calls": "FR: Calls",
    "Profile_Logs.request": "FR: Request",
    "Profile_Logs.response": "FR: Response",
    "Profile_Logs.error": "FR: Error",
    "Profile_Logs.timestampUtc": "FR: Timestamp (UTC)",
    "Profile_Logs.close": "FR: Close",
    "Profile_Logs.copy": "FR: Copy",
    "Profile_Logs.textCopied": "FR: Text Copied!",
    "Profile_Logs.noLogs": "FR: No logs yet!"
}
